import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";

const PrintPRModal = ({
  data,
  item,
  signature,
  logTickets,
  requestor,
  project,
  paymentTerm,
  showModal,
  closeModal,
}) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // convert YYYY-MM-DD to DD-MM-YYYY
  const formatDate = (unformatted_date) => {
    if(unformatted_date === '0000-00-00'){
      const formatted_date = null;
      return formatted_date;
    }else{
      const old_date = unformatted_date;
      const date = new Date(old_date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
  
      // concat
      const formatted_date = `${day}-${month}-${year}`;
      return formatted_date;
    }
    
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      backdrop="static"
      fullscreen
      contentClassName="print-modal"
    >
      <Modal.Header>
        <Modal.Title>View Print Layout</Modal.Title>
      </Modal.Header>
      <Modal.Body ref={componentRef}>
        {/* <div className="modal-body-div"> */}
        {/* <div className="print-layout" >            */}
        <table
          border={0}
          cellPadding={0}
          cellSpacing={0}
          // width={1550}
          style={{
            borderCollapse: "collapse",
            tableLayout: "fixed",
            // width: "1162pt",
          }}
        >
          <colgroup>
            <col
              width={52}
              style={{ msoWidthSource: "userset", width: "39pt" }}
            />
            <col
              width={78}
              style={{ msoWidthSource: "userset", width: "58.5pt" }}
            />
            <col
              width={100}
              style={{ msoWidthSource: "userset", width: "75pt" }}
            />
            <col width={61} style={{ width: "45.75pt" }} />
            <col
              width={82}
              style={{ msoWidthSource: "userset", width: "61.5pt" }}
            />
            <col
              width={81}
              style={{ msoWidthSource: "userset", width: "60.75pt" }}
            />
            <col
              width={87}
              style={{ msoWidthSource: "userset", width: "65.25pt" }}
            />
            <col
              width={75}
              style={{ msoWidthSource: "userset", width: "57.25pt" }}
            />
            <col
              width={72}
              style={{ msoWidthSource: "userset", width: "54pt" }}
            />
            <col
              width={80}
              style={{ msoWidthSource: "userset", width: "60pt" }}
            />
            <col
              width={72}
              style={{ msoWidthSource: "userset", width: "54pt" }}
            />
            <col
              className="x22"
              width={100}
              style={{
                msoWidthSource: "userset",
                background: "none",
                width: "75pt",
              }}
            />
          </colgroup>
          <tbody>
            <tr
              height={20}
              style={{ msoHeightSource: "userset", height: "15pt" }}
            >
              <td
                height={20}
                width={52}
                style={{ height: "15pt", width: "39pt" }}
              >
                <a name="Print_Area" />
              </td>
              <td colSpan={4} width={321} style={{ msoIgnore: "colSpan" }} />
              <td
                height={20}
                width={81}
                style={{
                  textAlign: "left",
                  height: "15pt",
                  width: "60.75pt",
                  verticalAlign: "top",
                }}
                align="left"
              >
                <span
                  style={{
                    msoIgnore: "vglayout",
                    position: "absolute",
                    zIndex: 1,
                    marginLeft: 25,
                    marginTop: 10,
                    width: 133,
                    height: 53,
                  }}
                >
                  <img
                    width={133}
                    height={53}
                    src="data:image/png;base64,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"
                    name="Picture1"
                    alt="\\Ls-chl-v2b15\share\Aexis003-Saleh\NEW AEXIS LOGO\new5.jpg"
                  />
                </span>
                <span style={{ msoIgnore: "vglayout2" }}>
                  <table cellPadding={0} cellSpacing={0}>
                    <tbody>
                      <tr>
                        <td
                          height={20}
                          width={81}
                          style={{ height: "15pt", width: "60.75pt" }}
                        />
                      </tr>
                    </tbody>
                  </table>
                </span>
              </td>
              <td colSpan={6} width={486} style={{ msoIgnore: "colSpan" }} />
            </tr>
            <tr
              height={60}
              style={{
                msoHeightSource: "userset",
                height: "45pt",
                msoXlrowspan: 3,
              }}
            >
              <td
                colSpan={12}
                height={20}
                style={{ msoIgnore: "colSpan", height: "15pt" }}
              />
            </tr>
            <tr
              height={25}
              style={{ msoHeightSource: "userset", height: "18.75pt" }}
            >
              <td
                colSpan={12}
                height={25}
                className="x55"
                style={{ height: "18.75pt" }}
              >
                PURCHASE REQUEST FORM
              </td>
            </tr>
            <tr
              height={20}
              style={{ msoHeightSource: "userset", height: "15pt" }}
            >
              <td
                colSpan={12}
                height={20}
                style={{ msoIgnore: "colSpan", height: "15pt" }}
              />
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "19.5pt" }}
            >
              <td
                colSpan={3}
                height={24}
                className="x43"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18pt",
                }}
              >
                Requestor
              </td>
              <td
                colSpan={4}
                className="x46"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                {requestor.user_fullname}
              </td>
              <td className="x43">Date</td>
              <td
                colSpan={3}
                className="x49"
                style={{ borderBottom: "1px solid windowtext" }}
              >
                {formatDate(data.purchase_created_at)}
              </td>
              <td className="x42">Payment Term</td>
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={3}
                height={24}
                className="x43"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              >
                Position
              </td>
              <td
                colSpan={4}
                className="x46"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                {requestor.position_name}
              </td>
              <td className="x43">PR Ref. No.</td>
              <td
                colSpan={3}
                className="x70"
                style={{ borderBottom: "1px solid windowtext" }}
              >
                {data.purchase_pr_ref_no}
              </td>
              <td
                rowSpan={2}
                height={52}
                className="x72"
                style={{
                  borderBottom: "1px solid windowtext",
                  height: "39.45pt",
                }}
              >
                {paymentTerm.payment_term_name}
              </td>
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={3}
                height={24}
                className="x43"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              >
                Project
              </td>
              <td
                colSpan={4}
                className="x46"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                {project.project_name}
              </td>
              <td className="x43">EDD</td>
              <td
                colSpan={3}
                className="x49"
                style={{ borderBottom: "1px solid windowtext" }}
              >
                {formatDate(data.purchase_edd)}
              </td>
            </tr>
            <tr
              height={20}
              style={{ msoHeightSource: "userset", height: "15pt" }}
            >
              <td
                colSpan={12}
                height={20}
                style={{ msoIgnore: "colSpan", height: "15pt" }}
              />
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "19.9pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x64"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.4pt",
                }}
              >
                Justification/Reason For Purchase
              </td>
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x67"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              >
                {data.purchase_reason}
              </td>
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x67"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              >
                {logTickets ? (
                  <span>Log No.: {logTickets.log_ticket_number}</span>
                ) : (
                  <span>&nbsp;</span>
                )}
              </td>
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x67"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              />
            </tr>
            <tr
              height={26}
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x53"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              />
            </tr>
            <tr
              height={6}
              style={{ msoHeightSource: "userset", height: "4.9pt" }}
            >
              <td height={6} className="x22" style={{ height: "4.9pt" }}>
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22">
                <div style={{ display: "block", overflow: "hidden" }} />
              </td>
              <td className="x22" />
            </tr>
            <tr
              height={20}
              style={{ msoHeightSource: "userset", height: "15pt" }}
            >
              <td
                colSpan={12}
                height={20}
                className="x63"
                style={{ height: "15pt" }}
              >
                ( To support your purchase request, please attach at least three
                quotations)
              </td>
            </tr>
            <tr
              height={20}
              style={{ msoHeightSource: "userset", height: "15pt" }}
            >
              <td height={20} className="x23" style={{ height: "15pt" }} />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
              <td className="x23" />
            </tr>
            <tr
              height={26}
              className="x24"
              style={{ msoHeightSource: "userset", height: "19.9pt" }}
            >
              <td
                colSpan={12}
                height={24}
                className="x60"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.4pt",
                }}
              >
                Purchase Details (Quotations to be attached)
              </td>
            </tr>
            <tr
              height={63}
              className="x27"
              style={{ msoHeightSource: "userset", height: "47.45pt" }}
            >
              <td height={62} className="x25" style={{ height: "46.7pt" }}>
                No.
              </td>
              <td className="x25">
                Item Code <br />
                (if any)
              </td>
              <td
                colSpan={4}
                className="x56"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                Items Description
              </td>
              <td
                colSpan={2}
                className="x56"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                Supplier Name <br />
                (as per Quotation/Invoice)
              </td>
              <td className="x26">Quantity</td>
              <td className="x26">Claim Amount</td>
              <td className="x26">Unit Price (RM)</td>
              <td className="x26">Total Price (RM)</td>
            </tr>
            {/* item data */}
            {item &&
              item.map((item, index) => (
                <tr
                  height={26}
                  style={{ msoHeightSource: "userset", height: "20.1pt" }}
                  key={index}
                >
                  <td height={24} className="x39" style={{ height: "18.6pt" }}>
                    {index + 1}
                  </td>
                  <td className="x39">{item.item_code}</td>
                  <td
                    colSpan={4}
                    className="x54"
                    style={{
                      borderRight: "1px solid windowtext",
                      borderBottom: "1px solid windowtext",
                    }}
                  >
                    {item.description}
                  </td>
                  <td
                    colSpan={2}
                    className="x39"
                    style={{
                      borderRight: "1px solid windowtext",
                      borderBottom: "1px solid windowtext",
                    }}
                  >
                    {item.supplier_name}
                  </td>
                  <td className="x39">{item.quantity}</td>
                  <td className="x39">
                    {item.claim ? item.claim : <span>&nbsp;</span>}
                  </td>
                  <td className="x39">{item.unit_price.toFixed(2)}</td>
                  <td className="x39">{item.total_price.toFixed(2)}</td>
                </tr>
              ))}
            {/* end - item data */}
            <tr
              height="26"
              style={{ msoHeightSource: "userset", height: "20.1pt" }}
            >
              <td
                colSpan="11"
                height="24"
                className="x74"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "18.6pt",
                }}
              >
                <div style={{ float: "right" }}>Total&nbsp;</div>
              </td>
              <td className="x33">{data?.purchase_total_all?.toFixed(2)}</td>
            </tr>
            <tr
              height={19}
              style={{ msoHeightSource: "userset", height: "14.65pt" }}
            >
              <td height={18} className="x34" style={{ height: "13.9pt" }} />
              <td className="x35" />
              <td className="x35" />
              <td className="x35" />
              <td className="x35" />
              <td className="x35" />
              <td className="x35" />
              <td className="x36" />
              <td className="x36" />
              <td className="x36" />
              <td className="x37" />
              <td className="x41" />
            </tr>
            <tr
              height={58}
              style={{ msoHeightSource: "userset", height: "43.9pt" }}
            >
              <td
                colSpan={3}
                height={56}
                className="x89"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "42.4pt",
                }}
              >
                Prepared By
              </td>
              <td
                colSpan={3}
                className="x89"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                }}
              >
                Verified By
                <br />
                (Program Manager)
              </td>
              <td
                colSpan={3}
                height={58}
                width={234}
                style={{
                  textAlign: "left",
                  // borderRight: "1px solid windowtext",
                  // borderBottom: "1px solid windowtext",
                  height: "42.9pt",
                  width: "175.5pt",
                  verticalAlign: "top",
                }}
                align="left"
              >
                <span style={{ msoIgnore: "vglayout2" }}>
                  <table cellPadding={0} cellSpacing={0}>
                    <tbody>
                      <tr>
                        <td
                          colSpan={3}
                          height={58}
                          className="x90"
                          width={234}
                          style={{ height: "58pt", width: "176.5pt" }}
                        >
                          <input
                            type="checkbox"
                            name="checkbox-approve-sm"
                            checked={
                              signature &&
                              signature.some((sign) => sign?.position_id === 2)
                            }
                            readOnly
                          ></input>{" "}
                          Approved
                          <span style={{ msoSpacerun: "yes" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                          </span>
                          <input
                            type="checkbox"
                            name="checkbox-rejected-sm"
                            checked={
                              !signature &&
                              !signature.some((sign) => sign?.position_id === 2)
                            }
                            readOnly
                          ></input>{" "}
                          Reject
                          <br />
                          Approval 1 (Senior Management/HOD)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </td>
              <td
                colSpan={3}
                height={58}
                width={252}
                style={{
                  textAlign: "left",
                  borderRight: "1px solid windowtext",
                  borderLeft: "1px solid windowtext",
                  // borderBottom: "1px solid windowtext",
                  height: "43.9pt",
                  width: "189pt",
                  verticalAlign: "top",
                }}
                align="left"
              >
                <span style={{ msoIgnore: "vglayout2" }}>
                  <table cellPadding={0} cellSpacing={0}>
                    <tbody>
                      <tr>
                        <td
                          colSpan={3}
                          height={58}
                          className="x90"
                          width={252}
                          style={{ height: "58pt", width: "260pt" }}
                        >
                          <input
                            type="checkbox"
                            name="checkbox-approve-ceo"
                            checked={
                              signature &&
                              signature.some((sign) => sign?.position_id === 1)
                            }
                            readOnly
                          ></input>{" "}
                          Approved
                          <span style={{ msoSpacerun: "yes" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                          </span>
                          <input
                            type="checkbox"
                            name="checkbox-rejected-ceo"
                            checked={
                              !signature &&
                              !signature.some((sign) => sign?.position_id === 1)
                            }
                            readOnly
                          ></input>{" "}
                          Reject
                          <br />
                          Approver 2 (CEO)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </td>
            </tr>
            <tr
              height={52}
              style={{ msoHeightSource: "userset", height: "39pt" }}
            >
              <td
                colSpan={3}
                rowSpan={3}
                height={143}
                className="x83"
                style={{
                  borderRight: "1px solid windowtext",
                  height: "107.25pt",
                }}
              >
                <div className="col" style={{fontSize: "9pt"}}>
                  {signature
                    ? signature.map((sign, index) => {
                        if (sign.position_id === 4) {
                          return (
                            <div key={index}>
                              <img src={sign.signature_file_url} />
                              <br />
                              {sign.user_fullname}
                              <br />
                              {sign.user_job_role}
                              <br />
                              {sign.user_company}
                              <br />
                              {sign.user_on_site === 'N/A' ? null : sign.user_on_site}
                            </div>
                          );
                        }
                      })
                    : null}
                </div>
                …........................................................
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={143}
                className="x83"
                style={{
                  borderRight: "1px solid windowtext",
                  height: "107.25pt",
                }}
              >
                <div className="col" style={{fontSize: "9pt"}}>
                  {signature
                    ? signature.map((sign, index) => {
                        if (sign.position_id === 3) {
                          return (
                            <div key={index}>
                              <img src={sign.signature_file_url} />
                              <br />
                              {sign.user_fullname}
                              <br />
                              {sign.user_job_role}
                              <br />
                              {sign.user_company}
                              <br />
                              {sign.user_on_site === 'N/A' ? null : sign.user_on_site}
                            </div>
                          );
                        }
                      })
                    : null}
                </div>
                …........................................................
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={143}
                className="x83"
                style={{
                  borderRight: "1px solid windowtext",
                  height: "107.25pt",
                }}
              >
                <div className="col" style={{fontSize: "9pt"}}>
                  {signature
                    ? signature.map((sign, index) => {
                        if (sign.position_id === 2) {
                          return (
                            <div key={index}>
                              <img src={sign.signature_file_url} />
                              <br />
                              {sign.user_fullname}
                              <br />
                              {sign.user_job_role}
                              <br />
                              {sign.user_company}
                              <br />
                              {sign.user_on_site === 'N/A' ? null : sign.user_on_site}
                            </div>
                          );
                        }
                      })
                    : null}
                </div>
                …........................................................
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={143}
                className="x83"
                style={{
                  borderRight: "1px solid windowtext",
                  height: "107.25pt",
                }}
              >
                <div className="col" style={{fontSize: "9pt"}}>
                  {signature
                    ? signature.map((sign, index) => {
                        if (sign.position_id === 1) {
                          return (
                            <div key={index}>
                              <img src={sign.signature_file_url} />
                              <br />
                              {sign.user_fullname}
                              <br />
                              {sign.user_job_role}
                              <br />
                              {sign.user_company}
                              <br />
                              {sign.user_on_site === 'N/A' ? null : sign.user_on_site}
                            </div>
                          );
                        }
                      })
                    : null}
                </div>
                …........................................................
              </td>
            </tr>
            <tr
              height={40}
              style={{ msoHeightSource: "userset", height: "30pt" }}
            ></tr>
            <tr
              height={52}
              style={{ msoHeightSource: "userset", height: "39pt" }}
            ></tr>
            <tr
              height={52}
              style={{ msoHeightSource: "userset", height: "39pt" }}
            >
              <td
                colSpan={3}
                rowSpan={3}
                height={156}
                className="x77"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "117pt",
                }}
              >
                Date :{" "}
                {signature
                  ? signature.map((sign) => {
                      if (sign.position_id === 4) {
                        return formatDate(sign.signature_created_at);
                      }
                    })
                  : null}
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={156}
                className="x77"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "117pt",
                }}
              >
                Date :{" "}
                {signature
                  ? signature.map((sign) => {
                      if (sign.position_id === 3) {
                        return formatDate(sign.signature_created_at);
                      }
                    })
                  : null}
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={156}
                className="x77"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "117pt",
                }}
              >
                Date :{" "}
                {signature
                  ? signature.map((sign) => {
                      if (sign.position_id === 2) {
                        return formatDate(sign.signature_created_at);
                      }
                    })
                  : null}
              </td>
              <td
                colSpan={3}
                rowSpan={3}
                height={156}
                className="x77"
                style={{
                  borderRight: "1px solid windowtext",
                  borderBottom: "1px solid windowtext",
                  height: "117pt",
                }}
              >
                Date :{" "}
                {signature
                  ? signature.map((sign) => {
                      if (sign.position_id === 1) {
                        return formatDate(sign.signature_created_at);
                      }
                    })
                  : null}
              </td>
            </tr>
            <tr
              height={52}
              style={{ msoHeightSource: "userset", height: "39pt" }}
            ></tr>
            <tr
              height={52}
              style={{ msoHeightSource: "userset", height: "39pt" }}
            ></tr>
            {/*[if supportMisalignedColumns]*/}
            <tr height={0} style={{ display: "none" }}>
              <td width={52} style={{ width: "39pt" }} />
              <td width={78} style={{ width: "58.5pt" }} />
              <td width={100} style={{ width: "75pt" }} />
              <td width={61} style={{ width: "45.75pt" }} />
              <td width={82} style={{ width: "61.5pt" }} />
              <td width={81} style={{ width: "60.75pt" }} />
              <td width={87} style={{ width: "65.25pt" }} />
              <td width={75} style={{ width: "56.25pt" }} />
              <td width={72} style={{ width: "54pt" }} />
              <td width={80} style={{ width: "60pt" }} />
              <td width={72} style={{ width: "54pt" }} />
              <td width={100} style={{ width: "75pt" }} />
            </tr>
            {/*[endif]*/}
          </tbody>     
          <tfoot>
      <tr>
        <td>          
          <div className="page-footer-space"></div>
        </td>
      </tr>
    </tfoot>
        </table>
        <footer className="page-footer">
          <div className="footer-left" style={{ textAlign: "left" }}>
            Rev. No: 4
          </div>
          <div className="footer-center" style={{ textAlign: "center" }}>
            Eff. Date: 25/03/2024
          </div>
          <div className="footer-right" style={{ textAlign: "right" }}>
            ATSB/FR/FI-0002
            <br />
            Page 1 of 1
          </div>
        </footer>        
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handlePrint();
            closeModal();
          }}
        >
          Print Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrintPRModal;
